module.exports = __webpack_public_path__ + "static/safeguarding-67d669d68854b0f6abd04e8de8b5730f.jpg";